import { ContactForm } from "@src/components/ContactForm";
import { LoginButton } from "@src/components/LoginButton";

// https://fabricca.pro/delete-account (exigência da Apple)
export function Contact() {
  return (
    <div className="Contact-page">
      <LoginButton />
      <ContactForm mode="page" />
    </div>
  );
}
